<template>
  <div class="fs-text-tool">
    <div class="fs-text-font">
      <div class="fs-form fs-select">
        <!-- <v-select label="displayName" v-model="settingsModel.font" :clearable="false" :options="fonts"></v-select> -->
        <select v-model="settingsModel.font">
          <option v-for="(font, index) in fonts" :key="index" :value="font.family">{{ font.displayName }}</option>
        </select>
      </div>
    </div>
    <div class="fs-menu-separator"></div>
    <div class="fs-text-size">
      <span class="mi">format_size</span>
      <div class="fs-form fs-input-text">
        <input v-model="settingsModel.size" min="4" max="400" type="number" />
      </div>
    </div>
    <div class="fs-menu-separator"></div>
    <div class="fs-text-format">
      <a class="mi" :class="{ 'fs-active': isEnabled('bold', true) }" @click.prevent="setFormat('bold', !settingsModel.bold)">format_bold</a>
      <a class="mi" :class="{ 'fs-active': isEnabled('italic', true) }" @click.prevent="setFormat('italic', !settingsModel.italic)">format_italic</a>
      <a class="mi" :class="{ 'fs-active': isEnabled('underline', true) }" @click.prevent="setFormat('underline', !settingsModel.underline)">format_underlined</a>
    </div>
    <div class="fs-menu-separator"></div>
    <div class="fs-text-color">
      <color-picker v-model="settingsModel.color"></color-picker>
    </div>
    <div class="fs-menu-separator"></div>
    <div class="fs-text-align">
      <a v-if="settingsModel.align === 'left'" class="mi" :class="{ 'fs-active': isEnabled('align', 'left') }" @click.prevent="setFormat('align', 'center')">format_align_left</a>
      <a v-if="settingsModel.align === 'center'" class="mi" :class="{ 'fs-active': isEnabled('align', 'center') }" @click.prevent="setFormat('align', 'right')">format_align_center</a>
      <a v-if="settingsModel.align === 'right'" class="mi" :class="{ 'fs-active': isEnabled('align', 'right') }" @click.prevent="setFormat('align', 'justify')">format_align_right</a>
      <a v-if="settingsModel.align === 'justify'" class="mi" :class="{ 'fs-active': isEnabled('align', 'justify') }" @click.prevent="setFormat('align', 'left')">format_align_justify</a>
    </div>
    <div class="fs-menu-separator"></div>
    <div class="fs-form fs-select">
      <span class="fs-label icon-opacity">
        <span class="icon">
          <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.7866" cy="13.4338" r="7.18487" stroke="#516066" stroke-width="2.05714" />
            <circle cx="8.52765" cy="8.56641" r="7.18487" stroke="#516066" stroke-width="2.05714" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2486 6.03027C15.2099 5.55148 14.0534 5.28442 12.8345 5.28442C8.32488 5.28442 4.6691 8.9402 4.6691 13.4498C4.6691 14.3294 4.80816 15.1764 5.0655 15.9702C2.26089 14.6775 0.314209 11.8414 0.314209 8.55065C0.314209 4.04102 3.96999 0.385239 8.47962 0.385239C12.1097 0.385239 15.1865 2.75407 16.2486 6.03027Z" fill="#516066" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.43094 5.79856C9.77715 5.66913 10.1345 5.56252 10.5011 5.48057L15.777 10.834C15.6748 11.1858 15.5495 11.5278 15.4029 11.8583L9.43094 5.79856ZM7.23035 7.04014C7.4915 6.8337 7.76557 6.64287 8.05115 6.46908L14.6634 13.1785C14.475 13.4518 14.2704 13.7131 14.0509 13.961L7.23035 7.04014ZM5.56179 8.82157C5.75017 8.54823 5.95477 8.28693 6.1742 8.03907L12.9948 14.9599C12.7336 15.1663 12.4595 15.3571 12.174 15.5309L5.56179 8.82157ZM4.44817 11.1661C4.55043 10.8143 4.67572 10.4723 4.82231 10.1418L10.7941 16.2014C10.4479 16.3308 10.0906 16.4374 9.72391 16.5194L4.44817 11.1661ZM4.17524 14.3637C4.1418 14.0635 4.12463 13.7585 4.12463 13.4494C4.12463 13.2733 4.13021 13.0985 4.14119 12.9252L7.87677 16.7157C7.35118 16.712 6.8374 16.6587 6.33988 16.5601L4.17524 14.3637ZM16.0841 9.07495L12.3482 5.28421C12.8738 5.28788 13.3876 5.3412 13.8851 5.43971L16.0501 7.63653C16.0835 7.93657 16.1006 8.24152 16.1006 8.55048C16.1006 8.72666 16.0951 8.90154 16.0841 9.07495Z" fill="#516066" />
        </svg>
        </span>
      </span>
      <select v-model="settingsModel.opacity" @change="setFormat('opacity', settingsModel.opacity)">
        <option v-for="item in numbersSequence(100, 5)" :key="item" :value="item">
          {{ `${item}%` }}
        </option>
      </select>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { markRaw } from 'vue';
import { Getter } from 'vuex-class';
import { Component, Inject, Watch } from 'vue-property-decorator';
import debounce from 'lodash.debounce';

import { fillRange, numbersSequence } from '@/helpers/array';
import { FontLoader } from '@/helpers/fonts';
import { FontFace } from '@/types';
import { FsCanvas, TextSettings, TextLayer, CANVAS_EVENTS, AbstractLayer } from '@filestack/canvas-sdk';
import isequal from 'lodash.isequal';
import ColorPicker from '@/components/ColorPicker.vue';

const DEBOUNCE_TIME = 250;

@Component({
  components: {
    ColorPicker,
  },
})
class TextTool extends Vue {
  protected settingsDebounceHandler: any;
  protected layerDebounceHandler: any;

  @Inject('canvas')
  private canvas: FsCanvas;

  @Getter('config')
  private config: any;

  private evHandler: any;

  private selected: TextLayer;

  protected get sizes(): number[] {
    return fillRange(4, 200, 2);
  }

  protected get fonts(): FontFace {
    return this.config('editor.text.fonts');
  }

  protected get numbersSequence() {
    return numbersSequence;
  }

  private get defaultFont() {
    return this.config('editor.text.fonts').find((el: any) => el.default);
  }

  private get defaultSettings(): TextSettings {
    return {
      ...this.settingsModel,
      ...this.config('editor.text.defaults'),
      font: this.defaultFont.family,
    };
  }

  private settingsModel: TextSettings = {
    size: null,
    font: null,
    bold: false,
    underline: false,
    italic: false,
    backgroundColor: null,
    color: null,
    align: 'left',
    opacity: 100,
  };

  private getLayerSettings(textLayer: AbstractLayer): TextSettings {
    if (textLayer && textLayer instanceof TextLayer) {
      return textLayer.getSettings();
    }

    return this.defaultSettings;
  }

  private mounted() {
    //  @ts-ignore
    this.selected = this.$route.params.selected;
    Vue.set(this, 'settingsModel', this.getLayerSettings(this.selected));

    this.evHandler = this.handleKeyboard.bind(this);

    FontLoader(this.config('editor.text.fonts')).then(() => {
      if (!this.selected) {
        this.canvas.layer.add(markRaw(new TextLayer(this.settingsModel)));
      }
    });

    this.canvas.on(CANVAS_EVENTS.SELECTION_CHANGED, this.selectionChangedCallback);
    this.canvas.on(CANVAS_EVENTS.LAYER_MODIFIED, this.onLayerModified);
    document.addEventListener('keydown', this.evHandler);
  }

  private beforeDestroy() {
    this.canvas.off(CANVAS_EVENTS.SELECTION_CHANGED, this.selectionChangedCallback);
    this.canvas.off(CANVAS_EVENTS.LAYER_MODIFIED, this.onLayerModified);
    document.removeEventListener('keydown', this.evHandler);
  }

  private handleKeyboard(e: KeyboardEvent) {
    // do not catch other keys
    // backspace and delete -> remove selected text
    if ([8, 46].indexOf(e.keyCode) === -1) {
      return;
    }

    // @ts-ignore
    if (e && e.target && ['INPUT', 'TEXTAREA'].indexOf(e.target.tagName) > -1) {
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    // @ts-ignore
    this.canvas.layer.remove(this.selected);
    this.canvas.saveState('textRemove');
    this.$router.push('/');
  }

  @Watch('settingsModel', { deep: true })
  private onSettingsUpdate() {
    if (this.selected && !isequal(this.selected.getSettings(), this.settingsModel)) {
      this.selected.setSettings(this.settingsModel);
      this.settingsDebounce();
    }
  }

  private settingsDebounce() {
    if (!this.settingsDebounceHandler) {
      this.settingsDebounceHandler = debounce(() => {
        if (this.selected) {
          this.canvas.saveState('textSettingsUpdate');
        }
      }, DEBOUNCE_TIME);
    }

    this.settingsDebounceHandler();
  }

  private selectionChangedCallback(data: TextLayer) {
    this.selected = data;
    Vue.set(this, 'settingsModel', this.getLayerSettings(data));
  }

  private onLayerModified() {
    if (!this.layerDebounceHandler) {
      this.layerDebounceHandler = debounce(() => {
          this.canvas.saveState('layerModified');
      }, DEBOUNCE_TIME);
    }

    this.layerDebounceHandler();
  }

  private isEnabled<T extends keyof TextSettings>(key: T, value: TextSettings[T]) {
    return this.settingsModel[key] === value;
  }

  private setFormat<T extends keyof TextSettings>(key: T, value: TextSettings[T]) {
    if (typeof this.settingsModel[key] === 'undefined') {
      return;
    }

    Vue.set(this.settingsModel, key, value);
  }
}

export default TextTool;
</script>
